// extracted by mini-css-extract-plugin
export var notificationHost = "_e4-0";